import { create } from 'zustand';

/** A single breadcrumb segment. Use `labelKey` for i18n keys, `label` for raw entity text. */
export interface Crumb {
	labelKey?: string;
	label?: string;
	path?: string;
}

interface BreadcrumbState {
	/** When set, overrides the route-derived crumbs (deep pages push entity names here). */
	override: Crumb[] | null;
	setOverride: (crumbs: Crumb[] | null) => void;
}

/**
 * Holds an optional breadcrumb override so deep page components can set the trail
 * (e.g. an entity name) without prop-drilling up to the topbar `<Breadcrumbs>`.
 * The `useBreadcrumbs` hook writes here; `<Breadcrumbs>` reads here and falls back
 * to auto-deriving from the route when `override` is null.
 */
export const useBreadcrumbStore = create<BreadcrumbState>(set => ({
	override: null,
	setOverride: crumbs => set({ override: crumbs })
}));
